import { createMuiTheme } from '@material-ui/core/styles';

// First define the theme only containing the theme palette
const paletteTheme = createMuiTheme({
  palette: {
    secondary: {
      main: 'rgb(72,184,104)',
      300: 'rgb(108,196,130)',
      100: 'rgb(192,229,200)'
    },
    primary: {
      dark: '#002B53',
      main: 'rgb(0,81,156)',
      100: 'rgb(79,125,206)',
      300: 'rgb(0,42,109)'
    },
    background: {
      default: '#FFF',
      paper: '#FFF'
    }
  },

  shape: {
    borderRadius: 0
  },

  typography: {
    h1: {
      fontSize: 28
    },
    h4: {
      fontSize: 18
    },
    h5: {
      fontSize: 16,
      fontWeight: 400
    },
    h6: {
      fontSize: 14,
      fontWeight: 500,
      textTransform: 'uppercase'
    },
    subtitle1: {
      fontSize: 12,
      color: 'rgba(0, 0, 0, 0.5)'
    }
  }
});

// Extend the palette theme with all the overrides. This allows us
// to access the palette properties inside the config.
const theme = createMuiTheme({
  ...paletteTheme,

  // Default props
  props: {
    MuiAppBar: {
      position: 'relative',
      color: 'inherit'
    },

    MuiTextField: {
      variant: 'outlined',
      fullWidth: true,
      margin: 'normal'
    },

    MuiCheckbox: {
      color: 'primary'
    },

    MuiCardHeader: {
      titleTypographyProps: {
        variant: 'h5'
      }
    }
  },

  // CSS overrides per component
  overrides: {
    MuiCardHeader: {
      action: {
        marginTop: 0,
        marginRight: 0,
        height: 19,
        display: 'flex',
        alignItems: 'center'
      }
    },

    MuiAppBar: {
      root: {
        boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)'
      }
    },
    MuiToolbar: {
      root: {
        justifyContent: 'space-between'
      },
      regular: {
        height: 115,
        padding: '0 40px'
      }
    },

    MuiButton: {
      root: {
        borderRadius: 0,
        textTransform: 'none'
      },
      contained: {
        boxShadow: 'none',
        '&:focus': {
          boxShadow: 'none'
        }
      },
      containedSecondary: {
        color: paletteTheme.palette.common.white
      }
    },

    MuiFormHelperText: {
      root: {
        '&$error::first-letter': {
          textTransform: 'capitalize'
        }
      }
    },

    MuiFormLabel: {
      root: {
        '&::first-letter': {
          textTransform: 'capitalize'
        }
      }
    },

    MuiOutlinedInput: {
      input: {
        padding: '16px 19px',
        height: 30
      },
      multiline: {
        padding: '16px 19px'
      },
      notchedOutline: {
        borderRadius: 4,
        borderColor: paletteTheme.palette.divider
      }
    },

    MuiSelect: {
      icon: {
        right: '19px',
        color: 'black'
      },
      select: {
        padding: '16px 19px',
        height: 30
      },
      selectMenu: {
        padding: '16px 19px',
        height: 30,
        display: 'flex',
        alignItems: 'center'
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '16px'
      }
    },
    MuiTypography: {
      h5: {
        fontFamily: 'Roboto Mono',
        lineHeight: '19px'
      }
    },
    MuiCardContent: {
      root: {
        padding: 20
      }
    }
  }
});

export default theme;
